import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import api from '../api/client';

type Category = 'todos' | 'documents' | 'passwords' | 'shopping' | 'calendar' | 'gifts' | 'families';

/**
 * Hook to mark all notifications for a category as read when visiting the page.
 * Also invalidates the notification counts query to update dashboard badges.
 */
export function useMarkCategoryRead(category: Category) {
  const queryClient = useQueryClient();

  useEffect(() => {
    const markAsRead = async () => {
      try {
        await api.post(`/notifications/mark-category-read/${category}`);
        // Invalidate notification counts to update dashboard badges
        queryClient.invalidateQueries({ queryKey: ['notificationCounts'] });
        queryClient.invalidateQueries({ queryKey: ['notifications'] });
      } catch (error) {
        // Silently fail - not critical
        console.error('Failed to mark notifications as read:', error);
      }
    };

    markAsRead();
  }, [category, queryClient]);
}
